import * as React from "react";
import Avatar from "@mui/material/Avatar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import Divider from "@mui/material/Divider";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Logout from "@mui/icons-material/Logout";
import PersonOutline from "@mui/icons-material/PersonOutline";
import LockReset from "@mui/icons-material/LockReset";
import { appActions, userActions } from "../../redux/actions";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ChangeOwnPasswordDialog from "../ChangeOwnPasswordDialog";
import useAuth from "../../hooks/useAuth";

export default function UserAccountMenu() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const auth = useAuth();
  const userAccountMenu = useSelector((state) => state?.app?.userAccountMenu || false);
  const [passwordOpen, setPasswordOpen] = React.useState(false);

  const open = Boolean(userAccountMenu);
  const handleClose = () => {
    dispatch(appActions.userAccountMenu(null));
  };

  const handleProfile = () => {
    handleClose();
    navigate("/profile");
  };

  const handleChangePassword = () => {
    handleClose();
    setPasswordOpen(true);
  };

  const handleLogout = () => {
    handleClose();
    dispatch(userActions.logout());
  };

  const displayName = auth.displayName || auth.contextLabel;

  return (
    <React.Fragment>
      <Menu
        anchorEl={userAccountMenu}
        id="account-menu"
        open={open}
        onClose={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            mt: 1.5,
            minWidth: 220,
            "& .MuiAvatar-root": {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            "&::before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <Box sx={{ px: 2, py: 1.25, maxWidth: 260 }}>
          <Typography variant="subtitle2" noWrap>
            {displayName}
          </Typography>
          <Typography variant="caption" color="text.secondary" noWrap>
            {auth.contextLabel}
            {auth.isTenantUser && auth.tenantLabel ? ` · ${auth.tenantLabel}` : ""}
          </Typography>
        </Box>
        <Divider />
        <MenuItem onClick={handleProfile}>
          <Avatar>
            <PersonOutline fontSize="small" />
          </Avatar>
          View Profile
        </MenuItem>
        <MenuItem onClick={handleChangePassword}>
          <ListItemIcon>
            <LockReset fontSize="small" />
          </ListItemIcon>
          Change Password
        </MenuItem>
        <Divider />
        <MenuItem onClick={handleLogout}>
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          Logout
        </MenuItem>
      </Menu>
      <ChangeOwnPasswordDialog
        open={passwordOpen}
        onClose={() => setPasswordOpen(false)}
      />
    </React.Fragment>
  );
}
